import React from 'react';

import shapeImg1 from '../../assets/img/about/shape-1-2.png';
import shapeImg2 from '../../assets/img/choose/shape-1-2.png';
import shapeImg3 from '../../assets/img/about/shape-1-1.png';
import aboutImg1 from '../../assets/img/about/about-1-1.jpg';
import aboutImg2 from '../../assets/img/about/about-1-2.jpg';
import aboutImg3 from '../../assets/img/about/about-1-3.jpg';
import aboutImg4 from '../../assets/img/about/about-1-4.jpg';
import aboutImg5 from '../../assets/img/about/about-1-5.jpg';
import avatarImg from '../../assets/img/about/avatar.png';

const About = () => {
  return (
    <div
      id="it-about"
      className="it-about-area p-relative fix z-index pt-120 pb-120"
    >
      <div className="it-about-shape-2">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-about-shape-3 d-none d-xxl-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div
            className="col-xl-5 col-lg-6 col-md-10 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-about-left">
              <div className="it-about-thumb-wrap p-relative d-flex justify-content-between align-items-center">
                <div className="it-about-thumb thumb-1">
                  <img src={aboutImg1} alt="" />
                </div>
                <div className="it-about-thumb-box">
                  <div className="it-about-thumb thumb-2">
                    <img src={aboutImg2} alt="" />
                  </div>
                  <div className="it-about-thumb thumb-3">
                    <img src={aboutImg3} alt="" />
                  </div>
                </div>
                <div className="it-about-thumb-box m-0">
                  <div className="it-about-thumb thumb-4">
                    <img src={aboutImg4} alt="" />
                  </div>
                  <div className="it-about-thumb thumb-5">
                    <img src={aboutImg5} alt="" />
                  </div>
                </div>
                <div className="it-about-shape-1">
                  <img src={shapeImg3} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-7 col-lg-6 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-about-right">
              <div className="it-about-title-box mb-20">
                <span className="it-section-subtitle">MORE ABOUT US</span>
                <h3 className="it-section-title">
                  We are always ensure best medical treatment for <br />
                  your <span>health</span>
                </h3>
              </div>
              <div className="it-about-text mb-30">
                <p>
                  Health and medical is a category that encompasses a wide range
                  of topics related to health and wellness. This category
                  includes medical treatments, preventative care, mental health,
                  fitness
                </p>
              </div>
              <div className="it-about-list-wrap mb-45">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="it-about-list style-1">
                      <ul>
                        <li>
                          <i className="flaticon-check-mark"></i>24/7 call
                          Services Availble
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>Instant
                          Operation & Appointment
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>From Scientific
                          Journal
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="it-about-list style-2">
                      <ul>
                        <li>
                          <i className="flaticon-check-mark"></i>How to improve
                          business
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>Medicine &
                          Instrument
                        </li>
                        <li>
                          <i className="flaticon-check-mark"></i>100% Expert
                          Doctors
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="it-about-bottom flex-wrap d-sm-flex align-items-center">
                <div className="it-about-author-info d-flex align-items-center">
                  <div className="it-about-author-thumb">
                    <img src={avatarImg} alt="" />
                  </div>
                  <div className="it-about-author-text">
                    <h5>Jane Cooper</h5>
                    <span>co founder</span>
                  </div>
                </div>
                <div className="it-about-tel-box d-flex align-items-center">
                  <div className="it-about-tel-icon">
                    <span>
                      <i className="flaticon-phone-call"></i>
                    </span>
                  </div>
                  <div className="it-about-tel-text">
                    <span>Need help?</span>
                    <a href="tel:8085550111">(808) 555-0111</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
